enum UrlTypes {
  CATEGORY = 'Category',
  CATEGORY_DESCRIPTION = 'Category Description',
  PRODUCT = 'Product',
  PRODUCT_DESCRIPTION = 'Product Description',
  PAGE = 'Page',
  PAGE_DESCRIPTION = 'Page Description',
  OTHER = 'Other',
  CATEGORY_HUB = 'Category Hub',
  UNCLASSIFIED = 'Unclassified',
}

export default UrlTypes;